export const Edit = (props: React.SVGProps<SVGSVGElement>) => (
	<svg
		data-aid="svgEdit"
		width="24"
		height="24"
		viewBox="0 0 24 24"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			fill="currentColor"
			d="M18.6533 10.7226L18.6466 10.7294L9.75456 19.5429C9.57613 19.7198 9.37297 19.8572 9.15612 19.9552C9.10191 19.9924 9.04326 20.025 8.98048 20.0521L4.87244 21.8253C3.2056 22.5448 1.48932 20.9161 2.14195 19.2343L3.78 15.0129C3.87255 14.6923 4.04619 14.3899 4.30093 14.1374L15.9462 2.59483C16.7464 1.80172 18.0438 1.80172 18.8439 2.59484L21.3999 5.12823C22.2 5.92134 22.2 7.20723 21.3999 8.00035L18.6533 10.7226ZM19.951 6.56429L17.3951 4.03089L16.0906 5.32386L18.6466 7.85727L19.951 6.56429ZM5.75455 15.5782C5.75608 15.5736 5.75758 15.5689 5.75905 15.5643L14.6216 6.77997L17.1775 9.31335L8.30571 18.1069L5.75455 15.5782ZM4.95064 17.6535L4.05435 19.9633L6.30213 18.9931L4.95064 17.6535Z"
		/>
	</svg>
);
